import React from 'react';
import { List, TextField, Datagrid, DateField, Filter, TextInput, ReferenceInput, SelectInput } from 'admin-on-rest';

const GridFilters = (props) => (
    <Filter {...props} className="filter">
		<TextInput label="Site source bevat" source="site_source" alwaysOn />
		<ReferenceInput label="Adverteerder" source="entity_identification" linkType={false} reference="admin/customers" alwaysOn>
            <SelectInput optionText="customerdomainid" optionValue="customerdomainid"/>
        </ReferenceInput>
    </Filter>
);

export const ReviewList = (props) => (
    <List title="Cloudhints - Websites" perPage={100} {...props} filters={<GridFilters />} >
        <Datagrid perPage={100} >
			<DateField source="created_at" sortable={false} showTime />
            <TextField source="id" sortable={false} />
            <TextField source="subject" sortable={false} />
            <TextField source="review" sortable={false} />
            <TextField source="rating" sortable={false} />
            <TextField source="entity_identification" sortable={false} />
            <TextField source="site_source" sortable={false} />         
		</Datagrid>
    </List>
);



// WEBPACK FOOTER //
// ./src/review/ReviewList.js